import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssignedProjectsComponent } from 'root/user/assigned-projects/assigned-projects.component';
import { AssignedStatusesComponent } from 'root/user/assigned-statuses/assigned-statuses.component';
import { UserComponent } from 'root/user/user/user.component';
import { AssignedStatusesResolver, ProjectStatusesResolver } from './user-resolvers';

export { AssignedStatusesResolver, ProjectStatusesResolver } from './user-resolvers';

const routes: Routes = [
  {
    path: '',
    component: UserComponent,
    data: { title: 'PAGE_TITLES.ROOT.users' },
  },
  {
    path: ':managerId/project/:projectId/assigned-statuses',
    component: AssignedStatusesComponent,
    resolve: {
      statuses: ProjectStatusesResolver,
      assignedStatuses: AssignedStatusesResolver,
    },
    data: { title: 'PAGE_TITLES.ROOT.assigned_statuses' },
  },
  {
    path: ':managerId/assigned-projects',
    component: AssignedProjectsComponent,
    data: { title: 'PAGE_TITLES.ROOT.assigned_projects' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
